import React from "react";
import { RCCGrid } from "react-common-components";
import BusinessDiagnosisCards from "src/components/DashboardComponents/Templates/BusinessDiagnosis";
import CanvasCards from "src/components/DashboardComponents/Templates/Canvas";
import DashboardListsIndicators from "src/components/DashboardComponents/Templates/Indicators/List";
import MapsCards from "src/components/DashboardComponents/Templates/Maps";
import SWOTCards from "src/components/DashboardComponents/Templates/SWOT";
import DashboardComponentsActions from "src/components/DashboardComponents/Templates/Actions/List";
import DashboardPieChartProjects from "../Templates/Projects/PieChart";
import DashboardListClassificationOKRs from "../Templates/OKRs/List";
import DashboardListsOccurrences from "../Templates/Occurrences/ListOrigin";
import DashboardListClassificationRisks from "../Templates/Risks/List";
import DashboardSummaryAuditsType from "../Templates/Audits/SummaryType";
import DashboardListMeetings from "../Templates/Meetings/ListMeetings";

const DefaultDashboard: React.FC = () => <RCCGrid container item wrap="wrap"> 
	<RCCGrid container item spacing={1} style={{ marginBottom: "0.5rem" }}>
		<RCCGrid container item xs={12} sm={6} md={3}>
			<CanvasCards />
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6} md={3}>
			<BusinessDiagnosisCards />
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6} md={3}>
			<SWOTCards />
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6} md={3}>
			<MapsCards />
		</RCCGrid>
	</RCCGrid>

	<RCCGrid container item spacing={1} style={{ marginBottom: "0.5rem" }}>
		<RCCGrid container item sm={12} md={6}>
			<DashboardListsIndicators />
		</RCCGrid>
		<RCCGrid container item sm={12} md={6}>
			<DashboardComponentsActions />
		</RCCGrid>
	</RCCGrid>

	<RCCGrid container item spacing={1} style={{ marginBottom: "0.5rem" }}>
		<RCCGrid container item sm={12} md={6}>
			<DashboardListClassificationOKRs />
		</RCCGrid>
		<RCCGrid container item sm={12} md={6}>
			<DashboardPieChartProjects />
		</RCCGrid>
	</RCCGrid>
	
	<RCCGrid container item spacing={1} style={{ marginBottom: "0.5rem" }}>
		<RCCGrid container item xs={12} sm={6}>
			<DashboardListsOccurrences />
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6}>
			<DashboardListClassificationRisks />
		</RCCGrid>
	</RCCGrid>

	<RCCGrid container item spacing={1}>
		<RCCGrid container item xs={12} sm={6}>
			<DashboardSummaryAuditsType />
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6}>
			<DashboardListMeetings />
		</RCCGrid>
	</RCCGrid>
</RCCGrid>;

export default DefaultDashboard;
